(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ai-text-launcher"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ignition-chat-launcher'))customElements.define('ignition-chat-launcher',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;const dialog=this.querySelector('dialog'),frame=this.querySelector('iframe'),launch=this.querySelector('.ignition-chat-launch');const open=()=>{if(!frame.hasAttribute('srcdoc')){frame.srcdoc=frame.dataset.document;frame.removeAttribute('data-document');}dialog.showModal();};launch.addEventListener('click',open);document.addEventListener('click',e=>{if(e.target.closest('a[href="#ignition-ai-chat"],[data-ai-chat-open]')){e.preventDefault();open();}});this.querySelector('.ignition-chat-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>launch.focus());window.addEventListener('message',e=>{if(e.source===frame.contentWindow&&e.origin===location.origin&&e.data?.type==='ignition-chat-close')dialog.close();});}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ims-shop-return"] && !Shopify.designMode) return;
  try {
    (() => {
  document.querySelectorAll('[data-ims-shop-return]').forEach(bar => {
    try {
      const saved=JSON.parse(sessionStorage.getItem('ims.shop.return.v1')||'null');
      if(!saved||saved.productId!==bar.dataset.productId||!Number.isFinite(saved.time)||Date.now()-saved.time>7200000||Date.now()<saved.time)return;
      const url=new URL(saved.url,location.origin),shop=new URL(bar.dataset.shopUrl,location.origin);
      if(url.origin!==location.origin||url.pathname!==shop.pathname)return;
      const modes=['accessories','gear','parts'];
      if(!modes.includes(saved.mode))return;
      url.hash='shop-results';
      bar.querySelector('[data-return-link]').href=url.href;
      bar.querySelector('[data-return-context]').textContent=String(saved.title||'').slice(0,200);
      if(saved.mode==='gear')bar.querySelector('[data-return-label]').textContent=bar.dataset.gearLabel;
      if(saved.mode==='accessories')bar.querySelector('[data-return-label]').textContent=bar.dataset.accessoriesLabel;
      bar.querySelector('[data-fitment-note]').hidden=!(saved.mode==='accessories'&&url.searchParams.has('machine'));
      bar.hidden=false;
    }catch(e){}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
